var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.9664H11.5104M11.5 7.90753V11.9412M5.68647 19H17.3135C19.1671 19 20.0938 19 20.6375 18.6222C21.1118 18.2925 21.4214 17.7849 21.4909 17.2231C21.5705 16.5793 21.1239 15.7922 20.2305 14.2179L14.4171 3.97268C13.4659 2.29656 12.9904 1.45849 12.362 1.18123C11.8144 0.939589 11.1856 0.939589 10.6379 1.18123C10.0095 1.45849 9.53398 2.29656 8.58291 3.97268L2.76939 14.2179C1.87612 15.7922 1.42948 16.5793 1.50906 17.2231C1.57849 17.7849 1.88816 18.2925 2.3625 18.6222C2.9061 19 3.83289 19 5.68647 19Z",
    stroke: "#DA0101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleIcon);
export default __webpack_public_path__ + "static/media/WarningTriangleIcon.e50952e978e546a445985e5a3ce778ae.svg";
export { ForwardRef as ReactComponent };